module.exports = __webpack_public_path__ + "static/img/sample-pic7.b46e335b.png";